import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate,useSearchParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import Login from './pages/Login';
import Step1 from './pages/Step1';
import Step2 from './pages/Step2';
import Step3 from './pages/Step3';
import StepSpark from './pages/StepSpark';
import Chat from './pages/Chat';
import Footer from './components/Footer';
import Auth from './pages/Auth';
import ListingDetails from './pages/ListingDetails';
import Widget from './pages/Widget';

// ProtectedRoute Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  if (!isAuthenticated && !isLoading) {
    return <Navigate to="/authorize" />;
  }
  return children;
};

// PlanTypeSetter Component
const PlanTypeSetter = () => {
  const [searchParams] = useSearchParams();
  const planType = searchParams.get("plan");
  useEffect(() => {
    if (planType) {
      localStorage.setItem("plan_type", planType);
    }  else {
      localStorage.removeItem("plan_type");
    }
  }, []);

  return null; // This component does not render anything
};

// App Component
function App() {
  return (
    <Router>
      <PlanTypeSetter /> {/* Include PlanTypeSetter to set plan_type in local storage */}
      <Routes>
        <Route path="/" element={<ProtectedRoute><Login /></ProtectedRoute>} />
        <Route path="/authorize" element={<Auth />} />
        <Route path="/step1" element={<ProtectedRoute><Step1 /></ProtectedRoute>} />
        <Route path="/step2" element={<ProtectedRoute><Step2 /></ProtectedRoute>} />
        <Route path="/step3" element={<ProtectedRoute><Step3 /></ProtectedRoute>} />
        <Route path="/stepspark" element={<ProtectedRoute><StepSpark /></ProtectedRoute>} />
        <Route path="/chat" element={<ProtectedRoute><Chat/></ProtectedRoute>} />
        <Route path="/chat/:queryParam" element={<ProtectedRoute><Chat/></ProtectedRoute>} />
        <Route path="/n/:queryParam" element={<ListingDetails/>} />
        <Route path="/n/:queryParam/:client" element={<ListingDetails/>} />
        <Route path="/widget" element={<Widget/>} />
        {/* Add more protected routes as needed */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
